<p-dialog header="Widget speichern"
          [visible]="visible"
          (visibleChange)="!$event && close()"
          [modal]="true"
          [closable]="!busy"
          [draggable]="false"
          [resizable]="false"
          styleClass="ui-ql-save-dialog">

    <div class="flex flex-column gap-3">

        <div class="flex flex-column gap-1">
            <label for="uiQlSaveName" class="font-medium">Name</label>
            <input pInputText id="uiQlSaveName" [(ngModel)]="name" [disabled]="busy" maxlength="255"/>
            @if (alias) {
                <small class="text-color-secondary">Alias: {{ alias }} (nach dem ersten Speichern unveränderlich)</small>
            } @else {
                <small class="text-color-secondary">Der Alias wird beim ersten Speichern aus dem Namen gebildet.</small>
            }
        </div>

        <div class="flex flex-column gap-1">
            <label for="uiQlSaveDescription" class="font-medium">Beschreibung</label>
            <textarea pTextarea id="uiQlSaveDescription" rows="3" [(ngModel)]="description" [disabled]="busy"></textarea>
        </div>

        <div class="flex flex-column gap-1">
            <label for="uiQlSaveSizes" class="font-medium">Angebotene Größen</label>
            <p-multiSelect inputId="uiQlSaveSizes"
                           [options]="sizeOptions"
                           optionLabel="label"
                           optionValue="value"
                           [ngModel]="sizes"
                           (ngModelChange)="onSizesChange($event)"
                           [disabled]="busy"
                           [showToggleAll]="false"
                           placeholder="Größen wählen"
                           appendTo="body"
                           styleClass="w-full"></p-multiSelect>
        </div>

        <div class="flex flex-column gap-1">
            <label for="uiQlSaveDefaultSize" class="font-medium">Standardgröße</label>
            <p-select inputId="uiQlSaveDefaultSize"
                      [options]="defaultSizeOptions"
                      optionLabel="label"
                      optionValue="value"
                      [(ngModel)]="defaultSize"
                      [disabled]="busy || !sizes.length"
                      placeholder="Standardgröße wählen"
                      appendTo="body"
                      styleClass="w-full"></p-select>
        </div>

        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        @if (violations?.length) {
            <p-message severity="error" styleClass="w-full">
                <div class="flex flex-column">
                    <span class="font-medium mb-2">Die Definition verstößt gegen die Regeln:</span>
                    <ul class="m-0 pl-4">
                        @for (violation of violations; track $index) {
                            <li class="mb-1">
                                {{ violationText(violation) }}
                                <span class="text-color-secondary text-sm" [pTooltip]="violation.message">({{ violation.code }}@if (violation.path) {, {{ violation.path }}})</span>
                            </li>
                        }
                    </ul>
                </div>
            </p-message>
        }
    </div>

    <ng-template #footer>
        <p-button label="Abbrechen" severity="secondary" [text]="true" [disabled]="busy" (onClick)="close()"></p-button>
        <p-button label="Speichern" icon="fa-solid fa-floppy-disk" [loading]="busy" [disabled]="!canSubmit" (onClick)="submit()"></p-button>
    </ng-template>
</p-dialog>
